import { render, staticRenderFns } from "./DialogResourceSubResourceServices.vue?vue&type=template&id=110001d7&"
import script from "./DialogResourceSubResourceServices.vue?vue&type=script&lang=js&"
export * from "./DialogResourceSubResourceServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports